import React from "react";

import Template from "@/components/guides/template";
import BreadCrumbs from "@/components/shared/bread-crumbs/BreadCrumbs";
import Link from "next/link";
import { routesURL } from "@/components/urls";
import useTitle from "@/components/hooks/useTitle";
import Footer from "@/components/landing-page/Footer";

const HowToStartGuide = () => {
  useTitle("Start Guide");
  const guideSteps = [
    {
      title: " Step 1 : Add your data source",
      Body: () => (
        <div>
          After successfull login into your account, you&apos;ll be on the
          dashboard screen. Click on the rounded plus icon to add your first
          data source you want to analyse.
        </div>
      ),
      image: "/images/guides/Start Guide -1.png",
    },
    {
      title: " Step 2 : Select a data source type ",
      Body: () => (
        <div>
          Once you have reached this screen, now you can select from a list of
          different data source types for you to connect and analyse.
          <br />
          <br />
          Provide relevant details for the data source and hit &quot;upload
          button&quot;. Upon successful upload or connection, you&apos;ll be
          redirected to the &quot;All Data source&quot; screen where you can
          view statuses of all your current datasources.
        </div>
      ),
      image: "/images/guides/Start Guide -2.png",
    },
    {
      title:
        " Step 3 : Dashboard - Type your question, choose a data source and toggle between chat/editor",
      Body: () => (
        <div>
          On the dashboard screen, to run your first analysis, type your
          question and select a data source from the dropdown menu located to
          the right of the question box.
          <br />
          <br />
          Next, choose an analysis mode. We offer Chat mode, which allows you to
          converse with your data as if it were a person, and Editor mode, which
          enables you to ask a question and write SQL directly in the SQL
          editor.
        </div>
      ),
      image: "/images/guides/Start Guide -3.png",
    },
    {
      title:
        "Step 4: Chat mode - Ask questions to data through an intuitive chat-like interface",
      Body: () => (
        <div>
          After typing your question and selecting chat mode, the AI will handle
          the response.
          <br />
          We've designed the interface to be simple, making it feel like you're
          conversing directly with your data source as if it were an actual
          person.
          <br />
          <br />
          You can also switch between different AI models like GPT3.5 (default),
          GPT4, GPT4-o, Claude-3 and see the differences.
        </div>
      ),
      image: "/images/guides/Start Guide -4.png",
    },
    {
      title: "Step 5: Editor mode - Write SQL directly in editor",
      Body: () => (
        <div>
          We specifically designed Editor mode for SQL enthusiasts who prefer to
          write queries in SQL for analysis.
          <br />
          Our aim was to offer a native SQL writing experience in an editor,
          without any compromises.
        </div>
      ),
      image: "/images/guides/Start Guide -6.png",
    },
    {
      title:
        "Step 6: Usage metrics - View different metrics like data queried, storage, time spent and more...",
      Body: () => (
        <div>
          As you continue to use Blockset you might also want to see metrics on
          how much data has been queried, what is the remaining storage for the
          current billing plan or maybe just want to know how many AI
          generations were made in chat/editor mode and more.
          <br />
          <br /> We provide a detailed view on these important metrics for you
          to know how billing is calculated for your plan.
        </div>
      ),
      image: "/images/guides/Start Guide -5.png",
    },
  ];
  return (
    <>
      <div className=" mx-auto max-w-[900px] max-sm:px-6">
        <BreadCrumbs>
          <Link href={routesURL.guides}>Guides</Link>
          <div>Start Guide</div>
        </BreadCrumbs>
      </div>
      <Template guideSteps={guideSteps} title={"Start Guide"} />
      <Footer />
    </>
  );
};

export default HowToStartGuide;
